import React, {FC} from 'react';
import box from '../../assets/images/icon-page/box.png';


const BoxIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Box Icon'}) => {
    return (
        <img
            src={box}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default BoxIcon;
